import React, { useEffect, useState } from 'react';
import { Col, Row, Form, FloatingLabel } from 'react-bootstrap';
import { fetchHVAOutboundCampaignNames } from 'services/hvaservicecampaign.service';
import HVASpinner from 'components/base/HVASpinner';
import CampaignCustomerListList from 'pages/hvamanagement/CampaignCustomerListList';

interface campaign {
  id: number;
  bxpcampaignid: number;
  name: string;
}

const CampaignCustomerList = () => {
  const [campaigns, setCampaigns] = useState<campaign[]>([]);
  // eslint-disable-next-line
  const [selectedCampaign, setSelectedCampaign] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // Cargar los campaigns
  useEffect(() => {
    const loadcampaigns = async () => {
      setIsLoading(true); // Inicia el loader
      try {
        const campaignNames = await fetchHVAOutboundCampaignNames();
        if (Array.isArray(campaignNames)) {
          setCampaigns(campaignNames);
        } else {
          throw new Error('Invalid response format');
        }
      } catch (error) {
        if (error instanceof Error) {
          setError('Error loading campaigns: ' + error.message);
        } else {
          setError('Unknown error occurred while loading campaigns');
        }
      } finally {
        setIsLoading(false); // Detiene el loader
      }
    };

    loadcampaigns();
  }, []);

  // Controlador para manejar la selección de campaign
  const handlecampaignChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCampaign(e.target.value);
  };

  return (
    <>
      <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 pt-0 pb-4 mb-0">
        <Row className="gy-3 mb-1 justify-content-between">
          <Col>
            <h2 className="mb-2 text-body-emphasis">
              Campaign Customer List Management
            </h2>
            <h5 className="text-body-tertiary fw-semibold">
              Start by selecting a campaign
              <span className="text-primary-dark fs-9">
                {' '}
                (only outbound campaigns)
              </span>
            </h5>
          </Col>
          <Col>
            <div className="d-flex w-100 align-items-center">
              <FloatingLabel
                controlId="campaigns"
                label="campaign selection"
                className="w-100"
              >
                {isLoading ? (
                  <HVASpinner />
                ) : (
                  <Form.Select
                    id="campaign"
                    value={selectedCampaign ?? ''}
                    onChange={handlecampaignChange}
                  >
                    <option value="">Select a campaign</option>
                    {campaigns.map(campaign => (
                      <option
                        key={campaign.bxpcampaignid}
                        value={campaign.bxpcampaignid.toString()}
                      >
                        {campaign.name}
                      </option>
                    ))}
                  </Form.Select>
                )}
              </FloatingLabel>
            </div>
          </Col>
        </Row>

        {/* Mostrar un mensaje de error si hay problemas al cargar las campaigns */}
        {error && <div className="text-danger mt-3">{error}</div>}
      </div>
      {selectedCampaign ? (
        <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis pt-0 mt-0 mb-0 border-top border-bottom">
          <Row className="gy-3 mt-0 justify-content-between bg-body-emphasis">
            <CampaignCustomerListList campaignId={Number(selectedCampaign)} />
          </Row>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default CampaignCustomerList;
